import { dateOf, dateTimeOf } from "@repo/helpers";
import { FC } from "react";

import style from "./style.module.scss";

interface Props {
	id?: string;
	label: string;
	value: string;
	dateOnly?: boolean;
}

export const TableDateDisplay: FC<Props> = ({ id, label, value, dateOnly }) => {
	return (
		<div className={style.grid} id={id}>
			<label className={style.label}>{label}</label>
			<span className={style.value}>{dateOnly ? dateOf(value) : dateTimeOf(value)}</span>
		</div>
	);
};
